import React from "react";
import "./StakingScenarios.css";

function StakingScenarios() {
  return (
    <div className="staking-scenarios-container">
      <h2 className="days-one">Staking Scenarios</h2>
      <p className="subheading">
        Navigating Diverse Staking Scenarios: From Single-Asset Strategies to
        Yield Optimization and Governance Participation in DeFi Ecosystems
      </p>

      <div className="scenarios-content">
        <div className="scenario">
          <h3 className="days-one">Scenario 1: User Without Insurance</h3>
          <ul>
            <li>Staked Amount: 10,000 INFINITY tokens</li>
            <li>Staking Period: 3 months</li>
            <li>APY: 23%</li>
            <li>Reward Earned: 575 INFINITY tokens</li>
            <li>Total Earnings: 2,300 INFINITY tokens</li>
          </ul>
        </div>

        <div className="scenario">
          <h3 className="days-one">
            Scenario 2: User With 100% Insurance and Buyback
          </h3>
          <ul>
            <li>Staked Amount: 10,000 INFINITY tokens</li>
            <li>Staking Period: 3 months</li>
            <li>Insurance Premium: $60</li>
            <li>APY: 23%</li>
            <li>Reward Earned: 575 INFINITY tokens</li>
            <li>Buyback Price: $6.03</li>
            <li>Total Earnings: $6.03 + 2,300 INFINITY tokens</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default StakingScenarios;
